<template>
  <div class="joinEx">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "joinEx", // 参展申请
  data() {
    return {

    };
  },
  components: {
  },
  computed: {

  },
  methods: {
    ...mapActions({

    }),
  },
  created() {
  }
};
</script>

<style scoped lang='scss'>
</style>